import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import { Box } from 'ui/Box';

import Routing from 'Routing';
import { styles } from 'StylesApp';
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={styles.root}>
        <Routing />
      </Box>
    </ThemeProvider>
  );
};

export default App;
